var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.074 66.7969C165.845 66.7969 164.371 66.7969 163.143 67.0417L156.017 79.5139C159.211 77.557 163.143 76.5793 167.074 76.5793C179.85 76.5793 190.415 87.0947 190.415 99.8117C190.415 112.529 179.85 123.044 167.074 123.044C154.297 123.044 143.978 112.773 143.732 100.056L136.362 112.529C141.275 124.511 153.315 132.827 166.828 132.827C185.01 132.827 199.997 117.908 199.997 99.8117C200.243 81.7149 185.255 66.7969 167.074 66.7969Z",
    fill: "#BF3078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8291 101.279L72.4803 91.4966L85.2567 113.262L99.998 88.0731L114.739 113.262L140.047 70.4652C141.275 68.2642 143.732 66.7969 146.435 66.7969H153.56L114.74 132.827L99.9987 107.637L85.2567 132.827L66.8291 101.279Z",
    fill: "#802050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3948 66.7969L38.5747 132.827L0 66.7969H7.1252C9.82775 66.7969 12.2848 68.2642 13.5134 70.4652L38.5747 113.507L63.8813 70.4652C65.1099 68.2642 67.5663 66.7969 70.2696 66.7969H77.3948Z",
    fill: "#26134D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVwo);
export default __webpack_public_path__ + "static/media/vwo.a0286866e0d74304e72a955627fa6424.svg";
export { ForwardRef as ReactComponent };